<template>
    <div class="articleEdit form">
        <div class="titleBox">
            <div class="title">新增文章</div>
        </div>
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
            <el-form-item label="文章标题" prop="title">
                <el-input v-model="ruleForm.title" maxlength="40" show-word-limit placeholder="请输入文章标题，不超过40个字"></el-input>
            </el-form-item>
            <el-form-item label="文章详情">
                <uEditor :content="ruleForm.desp" ref="uEditor1" @getUEditorContent="getTrySeeContent"></uEditor>
            </el-form-item>
            <el-form-item class="btnBox">
                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import UEditor from 'base/uEditor/uEditor2'
import {getDisEventArticleDetail, uploadDisEventArticle} from 'api/nationalDistribution'
export default {
    name: 'articleEdit',
    data() {
        return {
            ruleForm: {
                title: '',
                desp: ''
            },
            param: {
                articleinnerid: this.$route.query.articleinnerid ? this.$route.query.articleinnerid : '',
                eventinnerid: this.$route.query.eventinnerid ? this.$route.query.eventinnerid : ''
            },
            rules: {
                title: [
                    {required: true, message: '请输入文章标题', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        if (this.param.articleinnerid && this.param.eventinnerid) {
            this.getDetails()
        }
    },
    methods: {
        // 获取文章数据
        getDetails() {
            this.setLoading(true)
            getDisEventArticleDetail({
                data: this.param,
                success: data => {
                    this.setLoading(false)
                    this.ruleForm = data.data
                    let that = this
                    setTimeout(() => {
                        that.$refs.uEditor1.init(this.ruleForm.desp)
                    }, 1000)
                    console.log(data)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 文章详情
        getTrySeeContent(content) {
            this.ruleForm.desp = content
        },
        // 提交文章
        submitForm(formName) {
            this.$refs[formName].validate((value) => {
                if (value) {
                    this.setLoading(true)
                    uploadDisEventArticle({
                        data: Object.assign({}, this.ruleForm, this.param),
                        success: data => {
                            this.setLoading(false)
                            if (this.$route.query.articleinnerid) {
                                this.$router.push({name: 'NDArticleList', query: {refresh: '0', eventinnerid: this.$route.query.eventinnerid}})
                            } else {
                                this.$router.push({name: 'NDArticleList', query: {refresh: '1', eventinnerid: this.$route.query.eventinnerid}})
                            }
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    this.$message.error('请完善您的数据！')
                    return false
                }
            })
        },
        // 取消编辑
        cancel() {
            this.$router.push({name: 'NDArticleList', query: {refresh: '0', eventinnerid: this.$route.query.eventinnerid}})
        },
        ...mapActions([
            'setLoading',
            'setParams',
            'setPage'
        ])
    },
    computed: {
        ...mapGetters([
            'page',
            'user',
            'permission',
            'params'
        ])
    },
    components: {
        UEditor
    }
}
</script>
<style lang="scss">
    .articleEdit {
        background: #fff;
        // padding: 20px;
        .titleBox {
            padding: 20px;
            border-bottom: 1px solid #DCDFE6;
            margin-bottom: 20px;
            .title {
                border-left: 4px solid #409EFF;
                font-size: 14px;
                text-indent: 6px;
            }
        }
        .el-form {
            padding-bottom: 25px;
            .el-form-item {
                .el-form-item__label {
                    text-align: left;
                    text-indent: 20px;
                }
                .el-form-item__content {
                    .el-input {
                        width: 750px;
                    }
                }
            }
        }
        
    }
    .form {
        margin-top: 0;
    }
</style>